import { WebAddresses } from "../app.config";
import { User } from "./user";


/**
 * global user object that is used to authenticate to APIs
 */
export var globalUser = new User();

export var headerTitle : string = ""

/**
 * addresses to APIs that are compiled at runtime and easily changeable if needed
 */
//export var tCCTicketServer = WebAddresses.tCCTicketServer;